define('LNRS/Components/Jobs/JobDetails',["jquery", "eventManager"], function ($, eventManager) {

    function JobDetails(args) {
        if (args.isEditing) {
        } else {
            if (args.IsUK) {
                $('.job-detail-default-disclaimer').hide();
            }
            else {
                $('.job-detail-uk-disclaimer').hide();
            }

            const additionalLink = document.querySelector(".additional-location");
            if (additionalLink) {
                additionalLink.addEventListener("click", function (event) {
                    event.preventDefault(); // Prevent default anchor behavior
                    const targetHash = additionalLink.getAttribute("href");
                    if (targetHash) {
                        const target = document.querySelector(targetHash);
                        if (target) {
                            const headerOffset = 100; // Adjust to match your fixed header height
                            const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
                            const offsetPosition = elementPosition - headerOffset;
                            window.scrollTo({
                                top: offsetPosition,
                                behavior: "auto" // or "smooth" if you prefer
                            });
                        }

                    }
                 });
            }
        }
    }

    return function init(args) {
        
        return new JobDetails(args);
    };
});
